'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_ACTION = exports.UPDATE_ACTION = '@@i18n/LOCALE_UPDATE';
var LOG_PREFIX = exports.LOG_PREFIX = '[redux-intl-connect]';


//////////////////
// WEBPACK FOOTER
// ./~/redux-intl-connect/lib/constants.js
// module id = 30
// module chunks = 0